import { AuthApiService } from './../api/auth-api.service';
import router from './../routes'

export default {
  state: {
    user: null,
    requestInProgress: false
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    isRequestInProgress(state) {
      return state.requestInProgress;
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setIsRequestInProgress(state, isInProgress) {
      state.requestInProgress = isInProgress
    }
  },
  actions: {
    checkIfUserIsLoggedIn(context) {
      AuthApiService.getUser().then((user) => {
        context.commit('setUser', user);
      });
    },
    login(context, { email, password }) {
      context.commit('setIsRequestInProgress', true);
      AuthApiService.login(email, password).then(() => {
        AuthApiService.getUser().then((user) => {
          context.commit('setUser', user);
          context.commit('setIsRequestInProgress', false);
          router.goToHomePage();
        });
      }).catch(() => {
        context.commit('setIsRequestInProgress', false);
      })
    },
    register(context, registrationData) {
      context.commit('setIsRequestInProgress', true);
      AuthApiService.register(registrationData).then(() => {
        context.commit('setIsRequestInProgress', true);
        AuthApiService.getUser().then((user) => {
          context.commit('setUser', user);
          context.commit('setIsRequestInProgress', false);
          router.goToHomePage();
        });
      }).catch(() => {
        context.commit('setIsRequestInProgress', false);
      })
    },
    logout(context) {
      AuthApiService.logout();
      context.commit('setUser', null);
      router.push({ name: 'home' });
    }
  }
}
